import { Box, Flex, Text, useMantineColorScheme } from "@mantine/core";

import type { MantineStyleProp } from "@mantine/core";
import type { FC } from "react";

type SettingRowProps = {
  label: string;
  leftSection: string;
  rightSection: string;
  children?: React.ReactNode;
  right?: string;
} & MantineStyleProp;

export const SettingRow: FC<SettingRowProps> = ({
  label,
  leftSection,
  rightSection,
  children,
  right,
}) => {
  /* Theme */
  const { colorScheme } = useMantineColorScheme({ keepTransitions: true });
  const isDark = colorScheme === "dark";
  const textColor = isDark ? "primaryDark.4" : "secondary.6";

  return (
    <Flex py="md" justify="space-between" align="center">
      <Box miw={100}>
        <Text size="md" c={textColor}>
          {label}
        </Text>
      </Box>

      <Flex
        align="center"
        gap="md"
        miw="fit-content"
        pos={right ? "relative" : "inherit"}
        right={right}
      >
        <Text size="sm" c={textColor} w="4.5em" ta="right">
          {leftSection}
        </Text>
        {children}
        <Text size="sm" c={textColor} w="6em">
          {rightSection}
        </Text>
      </Flex>
    </Flex>
  );
};
